/**
 *  @class
 *  @function PredictiveSearch
 */
// class PredictiveSearch {
//   constructor() {
//     this.container = document.getElementById('Search-Drawer');
//     this.form = this.container.querySelector('form.searchform');
//     this.button = document.querySelectorAll('.thb-quick-search');
//     this.input = this.container.querySelector('input[type="search"]');
//     this.defaultTab = this.container.querySelector('.side-panel-content--initial');
//     this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');

//     this.setupEventListeners();
//   }

//   setupEventListeners() {
//     this.form.addEventListener('submit', this.onFormSubmit.bind(this));

//     this.input.addEventListener('input', debounce((event) => {
//       this.onChange(event);
//     }, 300).bind(this));

//     this.button.forEach((item, i) => {
//       item.addEventListener('click', (event) => {
//         var _this = this;
//         event.preventDefault();
//         document.getElementsByTagName("body")[0].classList.toggle('open-cc');
//         this.container.classList.toggle('active');
//         if (this.container.classList.contains('active')) {
//           setTimeout(function () {
//             _this.input.focus({
//               preventScroll: true
//             });
//           }, 100);
//           dispatchCustomEvent('search:open');
//         }

//         return false;
//       });
//     });
//   }

//   getQuery() {
//     return this.input.value.trim();
//   }

//   onChange() {
//     const searchTerm = this.getQuery();

//     if (!searchTerm.length) {
//       this.predictiveSearchResults.classList.remove('active');
//       return;
//     }
//     this.predictiveSearchResults.classList.add('active');
//     this.getSearchResults(searchTerm);
//   }

//   onFormSubmit(event) {
//     if (!this.getQuery().length) {
//       event.preventDefault();
//     }
//   }

//   onFocus() {
//     const searchTerm = this.getQuery();

//     if (!searchTerm.length) {
//       return;
//     }

//     this.getSearchResults(searchTerm);
//   }

//   getSearchResults(searchTerm) {
//     const queryKey = searchTerm.replace(" ", "-").toLowerCase();

//     this.predictiveSearchResults.classList.add('loading');

//     fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`)
//       .then((response) => {
//         this.predictiveSearchResults.classList.remove('loading');
//         if (!response.ok) {
//           var error = new Error(response.status);
//           throw error;
//         }

//         return response.text();
//       })
//       .then((text) => {
//         const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

//         this.renderSearchResults(resultsMarkup);
//       })
//       .catch((error) => {
//         throw error;
//       });
//   }

//   renderSearchResults(resultsMarkup) {
//     this.predictiveSearchResults.innerHTML = resultsMarkup;

//     let _this = this,
//       submitButton = this.container.querySelector('#search-results-submit');


//     submitButton.addEventListener('click', () => {
//       _this.form.submit();
//     });
//   }

//   close() {
//     this.container.classList.remove('active');
//   }
// }
// window.addEventListener('load', () => {
//   if (typeof PredictiveSearch !== 'undefined') {
//     new PredictiveSearch();
//   }
// });

class PredictiveSearch {
  constructor(container) {
    this.container = container;
    this.form = this.container.querySelector('form.searchform');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');
    this.setupEventListeners();
  }
  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    const searchTerm = this.getQuery();
    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      return;
    }
    this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm);
  }
  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }
  getSearchResults(searchTerm) {
    this.predictiveSearchResults.classList.add('loading');
    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        console.error("PredictiveSearch error:", error);
      });
  }
  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    const submitButton = this.container.querySelector('#search-results-submit');
    if (submitButton) {
      submitButton.addEventListener('click', () => {
        this.form.submit();
      });
    }
  }
  close() {
    this.container.classList.remove('active');
  }
}
// Initialize drawers on load
window.addEventListener('load', () => {
  document.querySelectorAll('.search-drawer').forEach((drawer) => {
    new PredictiveSearch(drawer);
  });
  // Link buttons to closest drawer
  document.querySelectorAll('.thb-quick-search').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const drawer = button.closest('body').querySelector('.search-drawer'); // Adjust this if needed
      if (!drawer) return;
      const isActive = !drawer.classList.contains('active');

      if (!isActive) {
        window.themeHeaderDrawers?.close();
      } else {
        window.themeHeaderDrawers?.open('Search-Drawer', ['open-search']);
      }

      if (isActive) {
        setTimeout(() => {
          const input = drawer.querySelector('input[type="search"]');
          if (input) input.focus({ preventScroll: true });
          dispatchCustomEvent('search:open');
        }, 100);
      }
    });
  });
});
// Debounce utility
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}
// Dispatch custom events (used to trigger 'search:open')
function dispatchCustomEvent(name, detail = {}) {
  const event = new CustomEvent(name, { detail });
  document.dispatchEvent(event);
}
